export type PaymentRegion =
  | 'AMS_PGS' // (PGS in Americas)
  | 'EMEA_PGS' // (PGS in Europe/Middle East/Africa)
  | 'EMEA_2CO' // (2Checkout in Central/Eastern Europe)
  | 'AP_2CO' // (2Checkout in Asia-Pacific)

const AMS_PGS_COUNTRIES = ['US', 'CA', 'PR']

const EMEA_PGS_COUNTRIES = [
  'UK',
  'DE',
  'FR',
  'ES',
  'IT',
  'IE',
  'NL',
  'BE',
  'LU',
  'AT',
  'PT',
  'SE',
  'DK',
  'NO',
  'FI',
  'CH',
  'GB'
]

const EMEA_2CO_COUNTRIES = [
  'CZ',
  'PL',
  'HU',
  'GR',
  'RO',
  'SK',
  'HR',
  'BG',
  'LV',
  'LT',
  'EE',
  'MT',
  'CY',
  'SI'
]

const AP_2CO_COUNTRIES = ['SG', 'HK', 'TW', 'NZ', 'AU']

export function getPaymentRegion(countryCode: string): PaymentRegion {
  const code = countryCode.trim().toUpperCase()

  if (AMS_PGS_COUNTRIES.includes(code)) {
    return 'AMS_PGS'
  }
  if (EMEA_PGS_COUNTRIES.includes(code)) {
    return 'EMEA_PGS'
  }
  if (EMEA_2CO_COUNTRIES.includes(code)) {
    return 'EMEA_2CO'
  }
  if (AP_2CO_COUNTRIES.includes(code)) {
    return 'AP_2CO'
  }

  return 'AMS_PGS'
}
